import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { ConfirmDialog } from '@/components/ui/Modal';
import { useAuthStore } from '@/stores/authStore';

export function useLogoutConfirmation() {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const logout = useAuthStore((state) => state.logout);
  const navigate = useNavigate();

  const promptLogout = useCallback(() => setOpen(true), []);

  const dismissLogout = useCallback(() => {
    if (!loading) setOpen(false);
  }, [loading]);

  const confirmLogout = useCallback(async () => {
    setLoading(true);
    try {
      await logout();
      toast.success('Logged out successfully');
      navigate('/login');
    } catch {
      toast.error('Logout failed');
      setLoading(false);
      setOpen(false);
    }
  }, [logout, navigate]);

  const logoutConfirmDialog = (
    <ConfirmDialog
      isOpen={open}
      onClose={dismissLogout}
      onConfirm={() => void confirmLogout()}
      title="Log out?"
      message="You'll need to sign in again to access your tabs and shared sessions."
      confirmText="Log out"
      cancelText="Stay signed in"
      variant="warning"
      isLoading={loading}
    />
  );

  return { promptLogout, logoutConfirmDialog };
}
